<div class="relative bg-white rounded-2xl overflow-hidden">
  <!-- Top Branding Strip -->
  <div class="bg-green-500 h-1.5 w-full"></div>

  <!-- Close Button -->
  <button 
    (click)="dialogRef.close()" 
    class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>

  <form [formGroup]="createPhoneSetUpForm" (ngSubmit)="onPhoneSetUpClick()" class="p-8">
    
    <!-- Icon & Heading -->
    <div class="flex flex-col items-center mb-10">
      <div class="bg-green-50 p-4 rounded-2xl mb-4 group-hover:scale-110 transition-transform duration-300">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-green-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.301-.15-1.779-.879-2.053-.979-.275-.1-.475-.15-.675.15-.199.299-.775.979-.95 1.174-.175.195-.349.219-.65.069-.301-.15-1.269-.468-2.417-1.492-.893-.797-1.496-1.782-1.671-2.081-.175-.3-.019-.462.131-.611.135-.134.301-.35.451-.524.151-.174.199-.299.301-.498.1-.199.05-.374-.025-.524-.075-.15-.675-1.625-.925-2.224-.244-.589-.493-.51-.675-.52l-.575-.01c-.199 0-.525.075-.799.374-.275.299-1.049 1.024-1.049 2.5s1.074 2.893 1.223 3.093c.15.199 2.113 3.227 5.119 4.526.715.31 1.273.495 1.708.634.717.228 1.369.196 1.884.119.574-.085 1.779-.726 2.029-1.427.25-.699.25-1.299.175-1.427-.075-.125-.275-.199-.575-.349z"/>
        </svg>
      </div>
      <h2 class="text-2xl font-extrabold text-slate-800 tracking-tight">Verify WhatsApp</h2>
      <!-- <p class="text-slate-500 text-sm mt-2 text-center max-w-[250px]">
        Enter your number to receive a secure communication link.
      </p> -->
    </div>

    <!-- Input Field -->
    <div class="relative mb-8">
      <input 
        type="tel" 
        maxlength="10" 
        id="phoneNo"
        formControlName="phoneNo"
        (keypress)="validateNumber($event)" 
        (keyup)="checkMobileNo($any($event.target).value)"
        required
        placeholder=" "
        class="peer w-full px-5 py-4 bg-slate-50 border-2 border-slate-100 rounded-2xl outline-none transition-all focus:bg-white focus:border-green-500 focus:ring-4 focus:ring-green-500/10"
      />
      
      <label 
        for="phoneNo"
        class="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none transition-all 
               peer-focus:-top-2 peer-focus:left-4 peer-focus:text-xs peer-focus:bg-white peer-focus:px-2 peer-focus:text-green-600 peer-focus:font-bold
               peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:left-4 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:bg-white peer-[:not(:placeholder-shown)]:px-2"
      >
        WhatsApp Number
      </label>

      <!-- Progress/Length Indicator -->
      <div class="flex items-center mt-3 px-1">
        <div class="h-1.5 flex-1 bg-slate-100 rounded-full overflow-hidden">
          <div class="h-full bg-green-500 transition-all duration-300" 
               [style.width]="(createPhoneSetUpForm.get('phoneNo')?.value?.length || 0) * 10 + '%'"></div>
        </div>
        <span class="ml-3 text-[11px] font-bold text-slate-400 tabular-nums">
          {{createPhoneSetUpForm.get('phoneNo')?.value?.length || 0}}/10
        </span>
      </div>
    </div>

    <!-- Submit Button -->
    <button 
      type="submit" 
      [disabled]="!showHideSubmitDiv"
      class="group relative w-full flex justify-center py-4 px-6 text-sm font-bold rounded-2xl text-white bg-green-600 hover:bg-green-700 shadow-lg shadow-green-200 active:scale-[0.98] transition-all disabled:opacity-50 disabled:grayscale disabled:cursor-not-allowed overflow-hidden"
    >
      <span class="relative z-10 flex items-center">
        PROCEED SECURELY
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </span>
      <!-- Shimmer Effect -->
      <div class="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shimmer"></div>
    </button>
    
    <div class="flex items-center justify-center mt-6 space-x-2 opacity-60">
      <svg class="w-3 h-3 text-slate-400" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
      </svg>
      <span class="text-[10px] text-slate-500 uppercase tracking-widest font-semibold">End-to-end encrypted</span>
    </div>
  </form>
</div>